const Spinner = () => <i className="spinner"></i>;

export default Spinner;